import React from 'react';

const CorrespondentChart = ({ data, totalEmails, onChartClick }) => {
  if (!data || !data.correspondents || data.correspondents.length === 0) {
    return (
      <div className="text-center py-8">
        <i className="bi bi-people text-4xl text-blue-500 mb-3 block"></i>
        <p className="text-slate-600">Aucune donnée de correspondant disponible</p>
      </div>
    );
  }

  const topCorrespondents = data.correspondents.slice(0, 8);
  const maxCount = Math.max(...topCorrespondents.map(c => c.count), 1);

  return (
    <div className="space-y-6" onClick={() => onChartClick && onChartClick('correspondents')}>
      {/* Graphique en barres pour les correspondants */}
      <div>
        <h6 className="font-semibold mb-4 text-slate-700">Top correspondants</h6>
        <div className="space-y-3">
          {topCorrespondents.map((correspondent, index) => {
            const percentage = (correspondent.count / maxCount) * 100;
            const emailPercentage = totalEmails > 0 ? (correspondent.count / totalEmails) * 100 : 0;
            
            return (
              <div key={index} className="flex items-center space-x-3">
                <div className="text-sm text-slate-600 w-32 truncate" title={correspondent.name || correspondent.email}>
                  {correspondent.name || correspondent.email}
                </div>
                <div className="flex-1">
                  <div className="bg-green-100 rounded-full h-4">
                    <div 
                      className="bg-green-600 h-4 rounded-full transition-all duration-300"
                      style={{ width: `${percentage}%` }}
                    ></div>
                  </div>
                </div>
                <div className="text-right w-20">
                  <div className="text-sm font-semibold text-slate-800">
                    {correspondent.count}
                  </div>
                  <div className="text-xs text-slate-500">
                    {emailPercentage.toFixed(1)}%
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Métriques résumées */}
      <div className="grid grid-cols-3 gap-4 text-center">
        <div className="bg-blue-50 rounded-lg p-3">
          <div className="text-lg font-bold text-blue-600">
            {data.total_correspondents || 0}
          </div>
          <div className="text-xs text-blue-700">Correspondants</div>
        </div>
        <div className="bg-green-50 rounded-lg p-3">
          <div className="text-lg font-bold text-green-600">
            {data.most_active?.count || 0}
          </div>
          <div className="text-xs text-green-700">Plus actif</div>
        </div>
        <div className="bg-purple-50 rounded-lg p-3">
          <div className="text-lg font-bold text-purple-600">
            {data.correspondents.length > 0 ? 
              ((data.correspondents[0].count / totalEmails) * 100).toFixed(1) : 0}%
          </div>
          <div className="text-xs text-purple-700">Top part</div>
        </div>
      </div>

      {/* Analyse des fréquences si disponible */}
      {data.communication_frequency && Object.keys(data.communication_frequency).length > 0 && (
        <div>
          <h6 className="font-semibold mb-3 text-slate-700">Fréquence de communication</h6>
          <div className="bg-slate-50 rounded-lg p-3">
            <div className="text-sm text-slate-600">
              {Object.entries(data.communication_frequency).slice(0, 3).map(([period, count], index) => (
                <div key={index} className="flex justify-between py-1">
                  <span>{period}:</span>
                  <span className="font-semibold">{count} emails</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CorrespondentChart;